module.exports = __webpack_public_path__ + "img/TECNOLOGIA-BALENO-4.1a978c16.jpg";